/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccountId } from "../../commons/types/AccountId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
import { AppId } from "../../commons/types/AppId";
import { ProgramId } from "../../commons/types/ProgramId";
import { SheetId } from "../../commons/types/SheetId";
export const TransformationCreateDto = core.serialization.object({
    accountId: AccountId,
    environmentId: EnvironmentId,
    spaceId: SpaceId,
    appId: AppId,
    programId: ProgramId.optional(),
    sheetId: SheetId,
    keys: core.serialization.list(core.serialization.string()),
    sourceKeys: core.serialization.list(core.serialization.string()),
    destinationKeys: core.serialization.list(core.serialization.string()),
    mutationCommand: core.serialization.string(),
    errorMessage: core.serialization.string().optional(),
    genesisValidationError: core.serialization.string().optional(),
    config: core.serialization.any(),
    type: core.serialization.string(),
});
